import {Model} from '@vuex-orm/core';
import User from "$src/models/userModel";
import Note from "$src/models/noteModel";

export default class Profile extends Model {

    static entity = 'profile';
    static primaryKey = 'id_user';

    static fields() {
        return {
            id_user: this.number(null),
            information: this.attr(null),
            membership: this.attr(null),
            contact: this.attr(null),
            medical: this.attr(null),
            food: this.attr(null),
            career: this.attr(null),
            family: this.attr(null),
            bank: this.attr(null),
            coordinators: this.attr([]),
            groups: this.attr([]),
            user: this.hasOne(User, 'id_user', 'id_user'),
            notes: this.hasMany(Note, 'id_user', 'id_user'),
            funded_by: this.attr({}),
        };
    }

}